import { DotsSixVertical } from '@phosphor-icons/react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React, { useState, useEffect } from 'react'
import { partnerContentStore } from 'state/setting/partnerContent'
import '../styles/reorder-modal.scss'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useReorderPartnerSlides } from 'api/Settings/PartnerContent'
import { myStore } from 'state/store'

const ReorderModal: React.FC = () => {
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [updatedOrder, setUpadtedOrder] = useState<
    { partnerId: string; order: number }[]
  >([])
  const { reorderSlidesModal, setReorderSlidesModal, slides } =
    partnerContentStore(store => ({
      reorderSlidesModal: store.reorderSlidesModal,
      setReorderSlidesModal: store.setReorderSlidesModal,
      slides: store.slides,
    }))

  const { mutate: reorderSliderMutation } = useReorderPartnerSlides()
  const { setSlides } = partnerContentStore(store => ({
    setSlides: store.setSlides,
  }))

  useEffect(() => {
    if (reorderSlidesModal && slides.length > 0) {
      setUpadtedOrder(
        slides.map((slide, idx) => {
          return {
            partnerId: slide.id as string,
            order: idx + 1,
          }
        }),
      )
    }
  }, [reorderSlidesModal, slides])

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return
    }

    const slidesCopy = [...slides]
    const [reorderedItem] = slidesCopy.splice(result.source.index, 1)
    slidesCopy.splice(result.destination.index, 0, reorderedItem)

    // Update store with reordered slides
    setSlides(slidesCopy)

    setUpadtedOrder(
      slidesCopy.map((slide, idx) => {
        return {
          partnerId: slide.id as string,
          order: idx + 1,
        }
      }),
    )
  }

  const handleSubmit = () => {
    if (updatedOrder.length === 0) {
      setReorderSlidesModal(false)
      return
    }

    const payload = {
      partners: updatedOrder,
    }
    setModalBtnLoader(true)
    reorderSliderMutation(payload, {
      onSuccess: () => {
        setModalBtnLoader(false)
        setReorderSlidesModal(false)
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }

  return (
    <CustomModal
      openModal={reorderSlidesModal}
      closeModal={setReorderSlidesModal}
      title="Reorder sections"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save new order"
          onSubmit={handleSubmit}
        />
      }
    >
      <p>
        Drag and reorder sections in the order you want them to appear in hero
        sections.
      </p>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="partnerSlides">
          {provided => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {slides.length > 0 &&
                slides.map((slide, index: number) => (
                  <Draggable
                    key={slide.id}
                    draggableId={String(slide.id)}
                    index={index}
                  >
                    {provided => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="drag-container">
                          <DotsSixVertical size={20} color="#000" />
                          <p
                            className="text-16 w-600"
                            dangerouslySetInnerHTML={{
                              __html:
                                slide.title?.replace(/^<p>|<\/p>$/g, '') || '',
                            }}
                          ></p>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </CustomModal>
  )
}

export default ReorderModal
